import React, {
	Component
} from 'react';


import styled from 'styled-components';

const Stroke = styled.span`

`

export class TextStroke extends Component {
	render(){
		var strokeStyle = {
			textShadow: `0.3vw 0.3vw 0.1vw ${this.props.color}, -0.3vw -0.3vw 0.1vw ${this.props.color}, 0.3vw -0.3vw 0.1vw ${this.props.color}, -0.3vw 0.3vw 0.1vw ${this.props.color}`
		}
		return (
			<Stroke style={strokeStyle}>{this.props.children}</Stroke>
		);
	}
}
